import { ReactNode, useEffect, useState } from 'react';

import OverlaySidebar from './OverlaySidebar';
import UIHeader from './UIHeader/UIHeader';
import UISideNav from './UISideNav/UISideNav';

const PlatformShell = ({ children, helpDrawerContent }: { children?: ReactNode; helpDrawerContent?: ReactNode }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [bannerHeight, setBannerHeight] = useState<string>('0px');

  useEffect(() => {
    const checkIntercomBanner = (mutations: MutationRecord[]) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          const banner = node as HTMLIFrameElement | HTMLButtonElement;
          if (banner.name === 'intercom-banner-frame') {
            const interval = setInterval(() => {
              // const { height } = banner.getBoundingClientRect();
              // const newHeight = height > 0 ? `${height}px` : '0px';
              const computedStyle = window.getComputedStyle(document.body);
              const newHeight = computedStyle.getPropertyValue('margin-top');
              if (newHeight !== bannerHeight) {
                setBannerHeight(newHeight);
              } else if (newHeight !== '0px') {
                clearInterval(interval);
              }
            }, 25);
          }
        });
        mutation.removedNodes.forEach((node) => {
          const banner = node as HTMLIFrameElement | HTMLButtonElement;
          if (banner.name === 'intercom-banner-frame') {
            setBannerHeight('0px');
          }
        });
      });
    };

    // Set up observer
    const observer = new MutationObserver(checkIntercomBanner);

    // Observe changes in body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, [bannerHeight]);

  return (
    <>
      <UIHeader
        helpDrawerContent={helpDrawerContent}
        marginBlockStart={bannerHeight}
        onNavOpenClick={() => {
          setIsNavOpen(true);
        }}
      >
        {children}
      </UIHeader>

      <UISideNav
        isOpen={isNavOpen}
        onOpenChange={(isOpen) => {
          setIsNavOpen(isOpen);
        }}
        marginBlockStart={bannerHeight}
      />

      <OverlaySidebar />
    </>
  );
};

export default PlatformShell;
